class ViewUploadControllerClass {
    constructor() {
        this.$onInit = () => {
            this.media = {};
            let params = this.resolve;
            this.media = params.media;
        };
        this.ok = () => {
            this.close();
        };
        this.cancel = () => {
            this.dismiss();
        };
    }
}
angular.module('app').component('utpUploadsModalController', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Upload/upload-modal.tpl.html',
    controllerAs: 'vm',
    controller: ViewUploadControllerClass
});
